var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _g, _path8, _ellipse2, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgTrumpetTopic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 54,
    viewBox: "0 0 59 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8269 47.8366L12.8755 36.8701C12.6167 36.5849 12.7951 36.1267 13.1785 36.0915L18.8439 35.5718C19.063 35.5517 19.2664 35.6873 19.3321 35.8973L22.0516 44.592C22.0792 44.6802 22.1324 44.7582 22.2043 44.8162L24.3233 46.5229C24.5613 46.7145 24.554 47.0793 24.3086 47.2613L23.4507 47.8978C23.258 48.0408 22.9882 48.0143 22.8269 47.8366Z",
    fill: "url(#paint0_linear_2434_12737)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.412 50.4717L11.5524 37.584C11.4678 37.3014 11.6632 37.0122 11.9569 36.9852L17.986 36.4321C18.2051 36.412 18.4085 36.5476 18.4742 36.7576L21.1937 45.4523C21.2213 45.5405 21.2745 45.6185 21.3464 45.6765L23.302 47.2516C23.5828 47.4777 23.5122 47.9232 23.1753 48.0514L16.0253 50.774C15.7718 50.8705 15.4898 50.7315 15.412 50.4717Z",
    fill: "url(#paint1_linear_2434_12737)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.70767,
    cy: 32.0522,
    r: 4.35694,
    transform: "rotate(-15.3094 9.70767 32.0522)",
    fill: "#CDA4CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73725 25.0579L17.3128 22.7104L21.0105 36.2179L12.4349 38.5654C12.4349 38.5654 9.01475 39.3403 7.13451 32.6759C5.25427 26.0114 8.73725 25.0579 8.73725 25.0579Z",
    fill: "url(#paint2_linear_2434_12737)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.2952,
    cy: 29.4774,
    rx: 3.89012,
    ry: 8.09145,
    transform: "rotate(-15.3094 20.2952 29.4774)",
    fill: "#CDA4CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4846 10.3784L40.601 38.4376C40.601 38.4376 33.4742 35.3873 29.8026 34.9404C26.131 34.4935 21.9769 36.1147 21.9769 36.1147C21.9769 36.1147 19.8614 36.0485 17.9384 30.2024C16.0154 24.3563 18.3203 22.7573 18.3203 22.7573C18.3203 22.7573 21.4113 22.5565 25.5503 19.4068C29.6893 16.2572 33.4846 10.3784 33.4846 10.3784Z",
    fill: "url(#paint3_linear_2434_12737)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1706 20.5898C53.6646 26.0474 53.9499 31.2173 53.2542 35.1408C52.5402 39.1674 50.9026 41.4258 48.9837 41.9511C47.0649 42.4764 44.5054 41.3669 41.8401 38.2654C39.243 35.2432 36.8553 30.6489 35.3613 25.1913C33.8674 19.7338 33.5821 14.5639 34.2778 10.6404C34.9918 6.61372 36.6294 4.35532 38.5482 3.83004C40.4671 3.30475 43.0266 4.41422 45.6919 7.51579C48.289 10.5379 50.6767 15.1323 52.1706 20.5898Z",
    fill: "url(#paint4_linear_2434_12737)",
    stroke: "url(#paint5_linear_2434_12737)",
    strokeWidth: 2.48968
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7174 22.3558C47.8049 29.9816 46.5742 36.9636 42.9686 37.9506C39.3629 38.9377 37.292 32.5368 35.2045 24.911C33.1169 17.2853 31.8033 11.3224 35.409 10.3354C39.0146 9.34833 43.6299 14.7301 45.7174 22.3558Z",
    fill: "url(#paint6_linear_2434_12737)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2434_12737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 17,
    width: 13,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4473 17.8957L35.1097 18.9681L34.6565 23.206L37.7962 31.139L46.0973 27.576L43.4473 17.8957Z",
    fill: "#8886DA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2434_12737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4473 17.8957L35.1097 18.9681L34.6565 23.206L37.7962 31.139L46.0973 27.576L43.4473 17.8957Z",
    fill: "#8886DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7137 27.6297C37.0453 27.3115 35.2367 19.8207 35.2367 19.8207L34.6611 24.4955L37.5827 32.8109L47.9439 28.5226L46.0922 25.8836C46.0922 25.8836 42.3821 27.9478 39.7137 27.6297Z",
    fill: "#7574B9",
    fillOpacity: 0.37
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2624 22.2875C46.623 23.6048 46.7639 24.8314 46.7099 25.7432C46.6827 26.2012 46.6077 26.5573 46.5025 26.8009C46.3953 27.049 46.2854 27.1211 46.2192 27.1392C46.153 27.1573 46.0216 27.1513 45.8031 26.9924C45.5885 26.8363 45.3425 26.5681 45.0859 26.1877C44.575 25.4306 44.0716 24.3033 43.7109 22.9859C43.3503 21.6686 43.2094 20.442 43.2634 19.5302C43.2906 19.0722 43.3656 18.7161 43.4709 18.4725C43.578 18.2245 43.6879 18.1523 43.7541 18.1342C43.8203 18.1161 43.9517 18.1222 44.1702 18.281C44.3848 18.4371 44.6308 18.7054 44.8874 19.0857C45.3983 19.8429 45.9017 20.9701 46.2624 22.2875Z",
    fill: "#8483BE",
    stroke: "#7574B9",
    strokeWidth: 0.778024
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1923,
    cy: 22.5002,
    rx: 0.544617,
    ry: 1.24484,
    transform: "rotate(-15.3094 45.1923 22.5002)",
    fill: "#BAA6D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1706 20.5898C53.6646 26.0474 53.9499 31.2173 53.2542 35.1408C52.5402 39.1674 50.9026 41.4258 48.9837 41.9511C47.0649 42.4764 44.5054 41.3669 41.8401 38.2654C39.243 35.2432 36.8553 30.6489 35.3613 25.1913C33.8674 19.7338 33.5821 14.5639 34.2778 10.6404C34.9918 6.61372 36.6294 4.35532 38.5482 3.83004C40.4671 3.30475 43.0266 4.41422 45.6919 7.51579C48.289 10.5379 50.6767 15.1323 52.1706 20.5898Z",
    stroke: "url(#paint7_linear_2434_12737)",
    strokeWidth: 2.48968
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7723 25.7103C19.7305 25.2593 19.9722 24.8294 20.3793 24.6307L24.7745 22.4865C25.4353 22.1641 26.2191 22.5756 26.3291 23.3026L26.5599 24.8289C26.6425 25.3751 26.3032 25.8966 25.7705 26.0424L21.2032 27.2927C20.5499 27.4715 19.8936 27.0171 19.831 26.3427L19.7723 25.7103Z",
    fill: "white",
    fillOpacity: 0.29
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6637 27.9924C10.6609 27.5694 10.9428 27.1974 11.3508 27.0857L13.389 26.5278C13.9806 26.3658 14.5651 26.8087 14.5691 27.4221L14.5723 27.9052C14.5751 28.3282 14.2932 28.7002 13.8852 28.8119L11.847 29.3698C11.2553 29.5318 10.6709 29.0889 10.6668 28.4755L10.6637 27.9924Z",
    fill: "white",
    fillOpacity: 0.19
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2434_12737",
    x1: 17.9799,
    y1: 35.651,
    x2: 23.7238,
    y2: 48.0154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFAEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2434_12737",
    x1: 17.122,
    y1: 36.5114,
    x2: 18.4227,
    y2: 50.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAA2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BBC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2434_12737",
    x1: 11.9852,
    y1: 24.1688,
    x2: 15.6829,
    y2: 37.6763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEADC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2434_12737",
    x1: 21.6294,
    y1: 36.6132,
    x2: 32.058,
    y2: 9.88155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC1C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2434_12737",
    x1: 25.2282,
    y1: 25.3033,
    x2: 51.9179,
    y2: 20.2557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC0C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2434_12737",
    x1: 38.2196,
    y1: 2.62937,
    x2: 49.3124,
    y2: 43.1518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2434_12737",
    x1: 47.6958,
    y1: 19.0716,
    x2: 13.9502,
    y2: 31.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8886DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323776,
    stopColor: "#8381DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2434_12737",
    x1: 38.2196,
    y1: 2.62937,
    x2: 49.3124,
    y2: 43.1518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB776"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTrumpetTopic);
export default __webpack_public_path__ + "static/media/img-trumpet-topic.e03fb8449e81de46ad9271bda70fbff3.svg";
export { ForwardRef as ReactComponent };